export default "__VITE_ASSET__C4l1IZ6d__"